import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        riad: 'Le Riad',
        rooms: 'Chambres',
        spaces: 'Espaces',
        services: 'Services',
        location: 'Localisation',
        availability: 'Disponibilités'
      },
      home: {
        exclusive: 'Privatisation Exclusive — Marrakech',
        title1: "L'art de vivre marocain",
        title2: "dans son expression",
        title3: "la plus noble",
        stat1: "400 m²",
        stat1Label: "D'ÉLÉGANCE",
        stat2: "10",
        stat2Label: "PERSONNES",
        stat3: "5",
        stat3Label: "CHAMBRES",
        stat4: "Kasbah",
        stat4Label: "QUARTIER HISTORIQUE",
        bookNow: "Réserver maintenant",
        discover: "Découvrir",
        experienceTitle: "L'expérience Riad KAMA",
        experienceHeading: "L'art de vivre marocain,<br/>réinventé pour vous",
        experienceText1: "Niché au fond d'un derb calme du quartier historique de la Kasbah, le Riad KAMA est une demeure d'exception entièrement privatisée qui célèbre l'élégance intemporelle de l'architecture marocaine.",
        experienceText2: "Récemment rénové avec un souci du détail obsessionnel, ce riad de 400 m² offre une expérience unique où l'authenticité ancestrale rencontre le confort moderne. Chaque espace a été pensé pour créer une atmosphère intime et apaisante, loin de l'agitation de la médina.",
        experienceText3: "Que vous soyez 2 ou 10 personnes, le riad vous est entièrement dédié. Aucun autre voyageur ne partagera ce lieu avec vous. C'est votre maison privée à Marrakech.",
        maxPeople: "Personnes maximum",
        maxPeopleDesc: "Idéal pour familles et groupes d'amis",
        elegantRooms: "Chambres élégantes",
        elegantRoomsDesc: "Chacune avec sa propre salle de bain",
        space: "m² d'espace",
        spaceDesc: "Entre tradition et modernité",
        galleryTitle: "Galerie",
        galleryHeading: "Un voyage visuel",
        ctaSubtitle: "Prêt pour l'expérience ?",
        ctaTitle: "Réservez votre séjour d'exception",
        ctaText: "Le Riad KAMA vous attend pour un séjour inoubliable dans l'intimité et le luxe de la Kasbah. Consultez nos disponibilités et contactez-nous pour un devis personnalisé.",
        ctaButton: "Consulter les disponibilités"
      },
      hero: {
        title: 'Votre riad privé d\'exception au cœur de Marrakech',
        subtitle: 'Une oasis de sérénité dans le quartier historique de la Kasbah',
        cta: 'Réserver votre séjour',
        checkAvailability: 'Voir les disponibilités'
      },
      highlights: {
        private: {
          title: 'Privatisation totale',
          desc: 'Le riad entier pour vous seul, quel que soit le nombre de personnes'
        },
        breakfast: {
          title: 'Petit-déjeuner inclus',
          desc: 'Savourez chaque matin sur notre rooftop avec vue panoramique'
        },
        location: {
          title: 'Kasbah, derb calme',
          desc: 'Au cœur de la médina, dans un havre de paix préservé'
        },
        rooftop: {
          title: 'Rooftop avec bassin',
          desc: 'Terrasse exclusive avec bassin et vue sur les toits de Marrakech'
        }
      },
      riad: {
        title: 'Le Riad',
        intro: 'Riad KAMA est un riad entièrement privatisé situé au cœur de la médina de Marrakech, dans le quartier historique de la Kasbah. Récemment rénové, il offre un cadre intime et authentique où chaque détail est pensé pour le bien-être des voyageurs. Les hôtes disposent de toute la maison quel que soit le nombre de personnes.',
        capacity: 'Capacité : 10 personnes',
        surface: 'Superficie : 400 m²',
        exclusivity: 'Location : uniquement en exclusivité'
      },
      rooms: {
        title: 'Chambres',
        subtitle: 'Cinq chambres élégantes pour votre intimité',
        room1: 'Chambre 1 - RDC',
        room2: 'Chambre 2',
        room3: 'Chambre 3',
        room4: 'Chambre 4',
        room5: 'Chambre Twin',
        features: {
          double: '4 chambres doubles lit 160 cm',
          twin: '1 chambre twin',
          bathroom: 'Salle de bain privée dans chaque chambre',
          ac: 'Climatisation'
        }
      },
      spaces: {
        title: 'Espaces',
        patio: {
          title: 'Patio central',
          desc: 'Le cœur du riad, avec sa fontaine traditionnelle et ses arches majestueuses'
        },
        lounges: {
          title: 'Deux salons',
          desc: 'Espaces confortables pour se détendre en famille ou entre amis'
        },
        massage: {
          title: 'Salle de massage',
          desc: 'Un espace dédié à votre bien-être et relaxation'
        },
        terrace: {
          title: 'Grande terrasse',
          desc: 'Profitez de l\'extérieur dans un cadre privilégié'
        },
        rooftop: {
          title: 'Rooftop avec bassin',
          desc: 'Vue panoramique sur les toits de la médina'
        },
        solarium: {
          title: 'Sur-terrasse solarium',
          desc: 'Pour profiter pleinement du soleil marocain'
        }
      },
      services: {
        title: 'Services',
        breakfast: {
          title: 'Petit-déjeuner inclus',
          desc: 'Chaque matin, savourez un petit-déjeuner marocain préparé avec soin'
        },
        housekeeper: {
          title: 'Gouvernante sur place',
          desc: 'À votre service pour un séjour sans souci'
        },
        cleaning: {
          title: 'Ménage quotidien',
          desc: 'Votre riad impeccable chaque jour'
        },
        dinner: {
          title: 'Dîner maison sur réservation',
          desc: 'Tajine : 20€ • Couscous royal : 25€ • Enfant : 15€'
        },
        wifi: {
          title: 'Wi-Fi haut débit',
          desc: 'Connexion internet rapide dans tout le riad'
        },
        transfer: {
          title: 'Transferts aéroport',
          desc: 'Service de navette disponible sur demande'
        },
        massage: {
          title: 'Massages',
          desc: 'Soins bien-être dans notre salle dédiée'
        }
      },
      location: {
        title: 'Localisation',
        subtitle: 'Au cœur de la Kasbah, tout est accessible à pied',
        intro: 'Situé au fond d\'un derb calme, le Riad KAMA offre une tranquillité rare tout en étant proche des principaux sites historiques de Marrakech.',
        distances: {
          title: 'Distances',
          saadiens: 'Tombeaux Saadiens — 3 min',
          mosque: 'Mosquée Moulay El Yazid — 4 min',
          ferblantiers: 'Ferblantiers — 5 min',
          badi: 'Palais El Badi — 8 min',
          koutoubia: 'Koutoubia — 10 min',
          jemaa: 'Jemaa el-Fna — 12 min'
        }
      },
      availability: {
        title: 'Disponibilités',
        subtitle: 'Consultez nos disponibilités et réservez votre séjour',
        loading: 'Chargement des disponibilités...',
        error: 'Disponibilités en cours de mise à jour',
        checkIn: 'Arrivée',
        checkOut: 'Départ',
        guests: 'Nombre de personnes',
        contact: 'Demande de réservation',
        intro: 'Le Riad KAMA se loue uniquement en privatisation totale. Consultez nos disponibilités ci-dessous et contactez-nous pour réserver votre séjour d\'exception.',
        capacity: 'Capacité : 10 personnes • 5 chambres • Location exclusive',
        available: 'Disponible',
        reserved: 'Réservé',
        whatsappText: 'Pour réserver votre séjour ou obtenir un devis personnalisé, contactez-nous directement sur WhatsApp',
        whatsappButton: 'Réserver sur WhatsApp'
      },
      contact: {
        title: 'Contact',
        subtitle: 'Réservez votre séjour d\'exception',
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        checkIn: 'Date d\'arrivée',
        checkOut: 'Date de départ',
        guests: 'Nombre de personnes',
        message: 'Message',
        submit: 'Envoyer la demande',
        whatsapp: 'Ou contactez-nous sur WhatsApp',
        success: 'Votre demande a été envoyée avec succès !',
        error: 'Une erreur est survenue. Veuillez réessayer.'
      },
      footer: {
        follow: 'Suivez-nous',
        legal: '© 2025 Riad KAMA. Tous droits réservés.',
        instagram: '@riad_kama_marrakech'
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        riad: 'The Riad',
        rooms: 'Rooms',
        spaces: 'Spaces',
        services: 'Services',
        location: 'Location',
        availability: 'Availability'
      },
      home: {
        exclusive: 'Exclusive Privatization — Marrakech',
        title1: "The art of Moroccan living",
        title2: "in its most",
        title3: "noble expression",
        stat1: "400 m²",
        stat1Label: "OF ELEGANCE",
        stat2: "10",
        stat2Label: "GUESTS",
        stat3: "5",
        stat3Label: "BEDROOMS",
        stat4: "Kasbah",
        stat4Label: "HISTORIC DISTRICT",
        bookNow: "Book now",
        discover: "Discover",
        experienceTitle: "The Riad KAMA experience",
        experienceHeading: "The art of Moroccan living,<br/>reinvented for you",
        experienceText1: "Nestled at the end of a quiet derb in the historic Kasbah district, Riad KAMA is an exceptional fully private residence that celebrates the timeless elegance of Moroccan architecture.",
        experienceText2: "Recently renovated with obsessive attention to detail, this 400 m² riad offers a unique experience where ancestral authenticity meets modern comfort. Every space has been designed to create an intimate and soothing atmosphere, away from the bustle of the medina.",
        experienceText3: "Whether you are 2 or 10 people, the riad is entirely dedicated to you. No other travelers will share this place with you. It's your private home in Marrakech.",
        maxPeople: "Maximum guests",
        maxPeopleDesc: "Ideal for families and groups of friends",
        elegantRooms: "Elegant rooms",
        elegantRoomsDesc: "Each with its own private bathroom",
        space: "m² of space",
        spaceDesc: "Between tradition and modernity",
        galleryTitle: "Gallery",
        galleryHeading: "A visual journey",
        ctaSubtitle: "Ready for the experience?",
        ctaTitle: "Book your exceptional stay",
        ctaText: "Riad KAMA awaits you for an unforgettable stay in the intimacy and luxury of the Kasbah. Check our availability and contact us for a personalized quote.",
        ctaButton: "Check availability"
      },
      hero: {
        title: 'Your private luxury riad in the heart of Marrakech',
        subtitle: 'An oasis of serenity in the historic Kasbah district',
        cta: 'Book your stay',
        checkAvailability: 'Check availability'
      },
      highlights: {
        private: {
          title: 'Full Privatization',
          desc: 'The entire riad for you alone, regardless of group size'
        },
        breakfast: {
          title: 'Breakfast Included',
          desc: 'Enjoy every morning on our rooftop with panoramic views'
        },
        location: {
          title: 'Kasbah, quiet derb',
          desc: 'In the heart of the medina, in a preserved haven of peace'
        },
        rooftop: {
          title: 'Rooftop with pool',
          desc: 'Exclusive terrace with pool and views over Marrakech rooftops'
        }
      },
      riad: {
        title: 'The Riad',
        intro: 'Riad KAMA is a fully private riad located in the heart of Marrakech\'s medina, in the historic Kasbah district. Recently renovated, it offers an intimate and authentic atmosphere where every detail is designed for guests\' comfort. Guests enjoy exclusive access to the entire house regardless of group size.',
        capacity: 'Capacity: 10 people',
        surface: 'Surface: 400 m²',
        exclusivity: 'Rental: exclusive only'
      },
      rooms: {
        title: 'Rooms',
        subtitle: 'Five elegant rooms for your privacy',
        room1: 'Room 1 - Ground Floor',
        room2: 'Room 2',
        room3: 'Room 3',
        room4: 'Room 4',
        room5: 'Twin Room',
        features: {
          double: '4 double rooms with 160 cm bed',
          twin: '1 twin room',
          bathroom: 'Private bathroom in each room',
          ac: 'Air conditioning'
        }
      },
      spaces: {
        title: 'Spaces',
        patio: {
          title: 'Central patio',
          desc: 'The heart of the riad, with its traditional fountain and majestic arches'
        },
        lounges: {
          title: 'Two lounges',
          desc: 'Comfortable spaces to relax with family or friends'
        },
        massage: {
          title: 'Massage room',
          desc: 'A space dedicated to your well-being and relaxation'
        },
        terrace: {
          title: 'Large terrace',
          desc: 'Enjoy the outdoors in a privileged setting'
        },
        rooftop: {
          title: 'Rooftop with pool',
          desc: 'Panoramic view over the medina rooftops'
        },
        solarium: {
          title: 'Upper terrace solarium',
          desc: 'To fully enjoy the Moroccan sun'
        }
      },
      services: {
        title: 'Services',
        breakfast: {
          title: 'Breakfast included',
          desc: 'Every morning, enjoy a carefully prepared Moroccan breakfast'
        },
        housekeeper: {
          title: 'On-site housekeeper',
          desc: 'At your service for a worry-free stay'
        },
        cleaning: {
          title: 'Daily cleaning',
          desc: 'Your riad spotless every day'
        },
        dinner: {
          title: 'Home-cooked dinner on request',
          desc: 'Tajine: €20 • Royal Couscous: €25 • Child: €15'
        },
        wifi: {
          title: 'High-speed Wi-Fi',
          desc: 'Fast internet connection throughout the riad'
        },
        transfer: {
          title: 'Airport transfers',
          desc: 'Shuttle service available on request'
        },
        massage: {
          title: 'Massages',
          desc: 'Wellness treatments in our dedicated room'
        }
      },
      location: {
        title: 'Location',
        subtitle: 'In the heart of the Kasbah, everything is within walking distance',
        intro: 'Located at the end of a quiet derb, Riad KAMA offers rare tranquility while being close to Marrakech\'s main historical sites.',
        distances: {
          title: 'Distances',
          saadiens: 'Saadian Tombs — 3 min',
          mosque: 'Moulay El Yazid Mosque — 4 min',
          ferblantiers: 'Ferblantiers — 5 min',
          badi: 'El Badi Palace — 8 min',
          koutoubia: 'Koutoubia — 10 min',
          jemaa: 'Jemaa el-Fna — 12 min'
        }
      },
      availability: {
        title: 'Availability',
        subtitle: 'Check our availability and book your stay',
        loading: 'Loading availability...',
        error: 'Availability being updated',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        guests: 'Number of guests',
        contact: 'Booking request',
        intro: 'Riad KAMA is rented only as a full privatization. Check our availability below and contact us to book your exceptional stay.',
        capacity: 'Capacity: 10 guests • 5 bedrooms • Exclusive rental',
        available: 'Available',
        reserved: 'Reserved',
        whatsappText: 'To book your stay or get a personalized quote, contact us directly on WhatsApp',
        whatsappButton: 'Book on WhatsApp'
      },
      contact: {
        title: 'Contact',
        subtitle: 'Book your exceptional stay',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        checkIn: 'Check-in date',
        checkOut: 'Check-out date',
        guests: 'Number of guests',
        message: 'Message',
        submit: 'Send request',
        whatsapp: 'Or contact us on WhatsApp',
        success: 'Your request has been sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      footer: {
        follow: 'Follow us',
        legal: '© 2025 Riad KAMA. All rights reserved.',
        instagram: '@riad_kama_marrakech'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;